module.exports = __webpack_public_path__ + "img/statistics_home.c2080366.png";